import { forceSyncReferredSiteVisits } from '../general/module/referredSiteVisit';
import { toggleSignInOverlay } from '../general/module/toggleSigninOverlay';

/**
 * Warning: because this endpoint returns 200 even in some error-cases, your onFailure function must be ready to accept
 * both successful requests (with a "response" object) and unsuccessful ones.
 */
export const submitEmailContactSignup = (name, manualZip, email, onSuccess, onFailure) => {
    let baseUrlForSignUp = window.baseURL;
    if (window.location.hostname.indexOf('secure') > -1) {
        baseUrlForSignUp = window.secureBaseURL;
    }
    const urlString = baseUrlForSignUp + 'common/email_contact_sign_up.html';
    let landingPageId = document.getElementById('landingPageId');
    if (landingPageId) {
        landingPageId = landingPageId.innerText;
    }

    $.ajax({
        url: urlString,
        dataType: 'json',
        type: 'POST',
        data: {
            email,
            name,
            manualZip,
            cartUUID: window.readCookie('cartUUID'),
            geoLocation: window.readCookie('geoLocation'),
            versionId: landingPageId,
        },
        success: (response) => {
            if (response && response.data && response.data.isExistingUser) {
                toggleSignInOverlay(null, true, { user: { username: email } });
                onSuccess(response);
            } else if (response && response.data && response.data.success) {
                forceSyncReferredSiteVisits(response.data.uuid);
                onSuccess(response);
            } else {
                onFailure(response);
            }
        },
        error: (xhr, status, err) => {
            onFailure(xhr, status, err);
        },
    });
};
